import styled from 'styled-components/macro'

export const StyledPartialApprove = styled.div`
  flex: 1;
  width: 100%;
`
